import React, { useEffect } from 'react'

export default function GameReviews({reviews, onLoad}) {
  useEffect(() => {
    onLoad()
  }, [])

  if (!reviews) return <div className='animated-spinner'></div>

  return <table className='table table-striped review-table'>
    <thead>
      <tr>
        <th>Time</th>
        <th>User</th>
        <th>Activity</th>
      </tr>
    </thead>
    <tbody>
      {
        reviews.map(review => {
          return <tr key={review.id}>
            <td>{review.date}</td>
            <td>{review.player_name}</td>
            <td>
              <b>{review.rate_title}</b>
              <p>{review.title}</p>
              <i>{review.body}</i>
              <p>
                <b>{'– – – – – – – – – – – – – – – – – – – – – – – – – – – – – – – – – –'}</b>
              </p>
              {
                review.player_reviews.map(pr => {
                  return <div key={pr.id}>
                    <p><b>{pr.description}</b></p>
                    <p>{pr.title}</p>
                    <p><i>{pr.body}</i></p>
                    <br/>
                  </div>
                })
              }
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}
